const Config = {
	apiBase: '/includes/api.php'
};

export default Config;



// WEBPACK FOOTER //
// ./src/Config.js